import { useParams } from 'react-router-dom';
import SurgeryInfoComponent from './SurgeryInfoComponent';
import useFetchAppointmentDetails from '../../hooks/queries/useFetchAppointmentDetails';

const SurgeryInfo = () => {
  const { id = '' } = useParams<{ id: string }>();

  const { data: appointment } = useFetchAppointmentDetails(id);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <SurgeryInfoComponent appointment={(appointment as any) || null} />;
};

export default SurgeryInfo;
